export enum InterfaceType {
    Unknown = 'Unknown',
    Lan = 'Lan',
    Bluetooth = 'Bluetooth',
    BluetoothLE = 'BluetoothLE',
    Usb = 'Usb'
}